import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import useApi from '../../helpers/TerserahApi';
import useAlertStore from '../../hooks/useAlert';
import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';
import {
  ReportButton,
  ReportModal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ReasonOption,
  TextArea,
  ModalFooter,
  SubmitButton,
  CancelButton
} from './style';

const ReportAd = ({ adId }) => {
  const { t } = useTranslation();
  const api = useApi();
  const navigate = useNavigate();
  const { showAlert } = useAlertStore();
  const [showModal, setShowModal] = useState(false);
  const [reason, setReason] = useState('');
  const [description, setDescription] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const isLoggedIn = () => !!Cookies.get('token');

  const reasons = [
    { value: 'spam', label: t('report_ad_reason_spam') },
    { value: 'inappropriate', label: t('report_ad_reason_inappropriate') },
    { value: 'fraud', label: t('report_ad_reason_fraud') },
    { value: 'duplicate', label: t('report_ad_reason_duplicate') },
    { value: 'other', label: t('report_ad_reason_other') }
  ];

  const handleReport = async () => {
    if (!isLoggedIn()) {
      showAlert(t('report_ad_login_required'), 'Login Required', 'warning');
      navigate('/signin');
      return;
    }

    if (!reason) {
      showAlert(t('report_ad_reason_required'), t('report_ad_reason_required'), 'warning');
      return;
    }

    setSubmitting(true);
    try {
      const json = await api.reportAd(adId, reason, description);
      if (json.success) {
        showAlert(t('report_ad_success'), t('review_success'), 'success');
        setShowModal(false);
        setReason('');
        setDescription('');
      } else {
        showAlert(json.error || t('report_ad_error'), t('error'), 'error');
      }
    } catch (err) {
      showAlert(t('report_ad_error'), t('error'), 'error');
    }
    setSubmitting(false);
  };

  return (
    <>
      <ReportButton onClick={() => {
        if (!isLoggedIn()) {
          showAlert(t('report_ad_login_required'), 'Login Required', 'warning');
          navigate('/signin');
        } else {
          setShowModal(true);
        }
      }}>
        {t('report_ad')}
      </ReportButton>

      {showModal && (
        <ReportModal>
          <ModalOverlay onClick={() => setShowModal(false)} />
          <ModalContent>
            <ModalHeader>
              <h3>{t('report_ad_title')}</h3>
              <p>{t('report_ad_subtitle')}</p>
            </ModalHeader>

            <ModalBody>
              <label>{t('report_ad_reason_label')}</label>
              {reasons.map(r => (
                <ReasonOption
                  key={r.value}
                  className={reason === r.value ? 'selected' : ''}
                  onClick={() => setReason(r.value)}
                >
                  {r.label}
                </ReasonOption>
              ))}

              <label style={{ marginTop: '20px' }}>{t('report_ad_details_label')}</label>
              <TextArea
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                placeholder={t('report_ad_details_placeholder')}
                rows="4"
              />
            </ModalBody>

            <ModalFooter>
              <CancelButton onClick={() => {
                setShowModal(false);
                setReason('');
                setDescription('');
              }}>
                {t('report_ad_cancel')}
              </CancelButton>
              <SubmitButton onClick={handleReport} disabled={submitting || !reason}>
                {submitting ? t('report_ad_submitting') : t('report_ad_submit')}
              </SubmitButton>
            </ModalFooter>
          </ModalContent>
        </ReportModal>
      )}
    </>
  );
};

export default ReportAd;
